// plugins/sweetalert2.ts
import Swal from 'sweetalert2'

export default defineNuxtPlugin(() => {
  return {
    provide: {
      Swal: Swal,
      // 頻繁に使う設定をまとめた独自メソッドを作成することも可能
      toast: (text: string, icon: 'success' | 'error' | 'warning' | 'info' = 'success') => {
        Swal.fire({
          text,
          icon,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true
        })
      },
      confirm: (title: string, text: string) => {
        return Swal.fire({
          title,
          text,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'キャンセル',
          reverseButtons: true
        })
      }
    }
  }
})
